import axios from 'axios';



export const courseUrl = 'https://course.3class.cc/'
export const bannerUrl = 'https://course.3class.cc/api/banner/v1/' 

export const codeUrl = 'https://judge.3class.cc'
export const chapterURL ='https://course.3class.cc/api/chapter/v1/'
export const judgeUrl = 'https://judge.3class.cc/api/judge/v1/' 
export const pkaUrl = 'https://judge.3class.cc/api/pka_score/v1/' 
export const toolUrl = 'https://course.3class.cc/api/tool/v1/' 
export const categoryUrl = 'https://course.3class.cc/api/category/v1/' 
export const userUrl = 'https://user.3class.cc/api/user/v1' 
export const wxUrl = 'https://user.3class.cc/wx/login/' 
export const loginUrl ='https://judge.3class.cc/api/user/v1/login'
const service = axios.create({
  baseURL: "http://127.0.0.1:8080/",
  timeout: 50000,
  withCredentials: false,
  transformRequest: [(data, headers) => {
    headers["X-Requested-With"] ='XMLHttpRequest'
    headers["Content-Type"] = 'application/json; charset=UTF-8'
    // if(localStorage.getItem("access_token")){
      headers["Authorization"] = 'Bearer sk-1hvc2fcb4b6fa98844d9c43331d74acef8792676079lXfI8' 

    headers['token']= localStorage.getItem('token')
    return JSON.stringify(data)
    
  }]
});

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// service.interceptors.response.use(
//   response => {
//     if(response.data.code != '0000') {
//       Message({message: response.data.data,type: "error"})
//       return
//     }
//     return Promise.resolve(response.data);

//   },
//   error => {
//     return Promise.reject(error)
//   }
// );


// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
        if(response.data.code == 250011) {
          
          localStorage.clear('id')
          localStorage.clear('username')
          localStorage.clear('head_img')
          localStorage.clear('phone')
          localStorage.clear('slogan')
          localStorage.clear('token')
          localStorage.clear('role')
              localStorage.clear("realName");
          location.reload()

          return
        }else if(res.code == 250004){
          
          localStorage.clear('id')
          localStorage.clear('username')
          localStorage.clear('head_img')
          localStorage.clear('phone')
          localStorage.clear('slogan')
          localStorage.clear('token')
          localStorage.clear('role')
              localStorage.clear("realName");
          location.reload()

          return
        }
    return res
  },
  error => {
        return Promise.reject(error)
  }
)
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js